import { useState } from 'react';
import { Eye, EyeOff, Leaf, LoaderCircle, LockKeyhole, Mail, ShieldCheck } from 'lucide-react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { firebaseConfigured } from '../services/firebase';
import { Notice } from '../components/UI';

export default function LoginPage() {
  const { user, adminProfile, login, authError } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  if (user && adminProfile) return <Navigate to="/" replace />;

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      await login(email.trim(), password);
    } catch (loginError) {
      const code = loginError?.code || '';
      if (code.includes('invalid-credential')) setError('Email athva password khoto chhe.');
      else if (code.includes('too-many-requests')) setError('Ghana login attempts thaya. Thodi vaar pachhi try karo.');
      else setError(loginError.message || 'Login thai shakyu nahi.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-visual">
        <div className="visual-orb orb-one" />
        <div className="visual-orb orb-two" />
        <div className="login-visual-content">
          <span className="login-logo"><Leaf size={29} /> JP</span>
          <p className="eyebrow light">Jashapar Gram Panchayat</p>
          <h1>Manage village information with confidence.</h1>
          <p>Businesses, events, contacts, bus timings ane village content ek secure dashboard mathi manage karo.</p>
          <div className="security-pill"><ShieldCheck size={19} /><span>Firebase protected admin access</span></div>
        </div>
      </section>

      <section className="login-panel">
        <form className="login-card" onSubmit={submit}>
          <div className="mobile-login-brand"><span>JP</span> Jashapar Portal</div>
          <p className="eyebrow">Admin Console</p>
          <h2>Welcome back</h2>
          <p className="login-subtitle">Authorized admin account thi sign in karo.</p>

          {!firebaseConfigured ? <Notice type="error">Firebase environment variables configure karo.</Notice> : null}
          {(error || authError) ? <Notice type="error">{error || authError}</Notice> : null}

          <label className="login-field">
            <span>Email address</span>
            <div><Mail size={19} /><input type="email" autoComplete="email" required value={email} placeholder="admin@example.com" onChange={(event) => setEmail(event.target.value)} /></div>
          </label>
          <label className="login-field">
            <span>Password</span>
            <div><LockKeyhole size={19} /><input type={showPassword ? 'text' : 'password'} autoComplete="current-password" required value={password} placeholder="Enter password" onChange={(event) => setPassword(event.target.value)} />
              <button type="button" onClick={() => setShowPassword((value) => !value)} aria-label="Toggle password visibility">{showPassword ? <EyeOff size={18} /> : <Eye size={18} />}</button>
            </div>
          </label>

          <button className="button primary login-button" type="submit" disabled={busy || !firebaseConfigured}>
            {busy ? <LoaderCircle className="spin" size={18} /> : <ShieldCheck size={18} />}{busy ? 'Signing in…' : 'Secure sign in'}
          </button>
          <small className="login-help">Access problem hoy to Super Admin no contact karo.</small>
        </form>
      </section>
    </main>
  );
}
